export const CHANGE_CLIENT_ID = "CHANGE_CLIENT_ID";

export function saveClientId(clientId) {
  return {
    clientId,
    type: CHANGE_CLIENT_ID,
  };
}
